import { AxiosError } from "axios";
import { TFunction } from "i18next";
import ApiResponse from "../Models/ApiResponse";

export const RESOURCE_PERMISSION_DENIED_CODES = [
    "IMSECBDPRM",
    "IMSECPFLPRM",
    "IMSECOBJPRM",
    "IMSECALRPRM",
    "IMSECPRJPRM",
] as const;

export const resolveApiErrorMessage = (
    error: unknown,
    fallbackKey: string,
    t: TFunction,
): string => {
    const axiosError = error as AxiosError<ApiResponse<unknown>>;
    console.error("resolveApiErrorMessage", {
        fallbackKey,
        status: axiosError?.response?.status,
        internalCode: axiosError?.response?.data?.internalCode,
        message: axiosError?.response?.data?.message ?? axiosError?.message,
        data: axiosError?.response?.data,
        error,
    });
    const messageKey = axiosError?.response?.data?.message;
    if (messageKey) {
        const translated = t(messageKey);
        if (translated !== messageKey) {
            return translated;
        }
    }
    return t(fallbackKey);
};

export const isResourcePermissionDenied = (error: unknown): boolean => {
    const axiosError = error as AxiosError<ApiResponse<unknown>>;
    const internalCode = axiosError?.response?.data?.internalCode;
    return !!internalCode && RESOURCE_PERMISSION_DENIED_CODES.includes(internalCode as typeof RESOURCE_PERMISSION_DENIED_CODES[number]);
};
